import { render, staticRenderFns } from "./AdditionalInfoComponent.vue?vue&type=template&id=1135894a&scoped=true"
import script from "./AdditionalInfoComponent.vue?vue&type=script&lang=js"
export * from "./AdditionalInfoComponent.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInfoComponent.vue?vue&type=style&index=0&id=1135894a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1135894a",
  null
  
)

export default component.exports